module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"店前通行客数"}}')
  delete Component.options._Ctor
}
